import React from "react";
import { useNavigate } from "react-router-dom";
import { LogOut, UserCheck } from "lucide-react";
import { useAuth } from "@/lib/auth";

/**
 * Sticky banner shown when the current session is an impersonation
 * (JWT contains an `imp` claim). Lets the platform operator exit cleanly.
 */
export default function ImpersonationBanner() {
  const { user, signOut } = useAuth();
  const navigate = useNavigate();

  if (!user?.impersonator_email) return null;

  const exit = async () => {
    await signOut();
    navigate("/login");
  };

  return (
    <div
      data-testid="impersonation-banner"
      className="sticky top-0 z-50 bg-amber-500 text-amber-950 border-b-2 border-amber-700"
    >
      <div className="max-w-7xl mx-auto px-4 py-2 flex items-center justify-between gap-3 text-xs font-medium">
        <div className="flex items-center gap-2">
          <UserCheck size={14} />
          <span>
            <strong>Customer mode</strong> — viewing as{" "}
            <span className="font-mono">{user.email}</span> · operator:{" "}
            <span className="font-mono">{user.impersonator_email}</span> ({user.impersonator_role})
          </span>
        </div>
        <button
          onClick={exit}
          data-testid="impersonation-exit"
          className="inline-flex items-center gap-1 px-3 py-1 rounded-md bg-amber-950 text-amber-50 hover:bg-black"
        >
          <LogOut size={12} /> Exit customer mode
        </button>
      </div>
    </div>
  );
}
